import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=0eba2b27&scoped=true&"
import script from "./UploadDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocuments.vue?vue&type=style&index=0&id=0eba2b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eba2b27",
  null
  
)

export default component.exports